exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".consent-box{margin-top:3rem;display:inline-block}.consent-box .consentemail-box,.consent-box .consentphone-box,.consent-box .consentpost-box{margin-left:-15px;margin-right:-15px}.consent-box h4{padding-top:3rem}.consent-box .content-box--actions{background-color:#5a5a5a;margin-bottom:20px}.consent-box .content-box--actions-label{padding:3rem 3rem 2rem}#section-main-form form div[class*=col-].consent-closed{margin-top:4rem;overflow-y:hidden;max-height:0;transition:max-height .4s ease-in-out}#section-main-form form div[class*=col-].consent-forced{margin-top:0}#section-main-form form div[class*=col-].consent-opened{max-height:1600px}@media (max-width:768px){#section-main-form form div[class*=col-].consent-opened{max-height:2600px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./js-src/markdown-editor/modules/consent/consent.styl
// module id = 38
// module chunks = 0 1